import * as React from "react";
import {connect} from "react-redux";
import {bindActionCreators} from "redux";
import {Link, Redirect} from "react-router-dom";
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import YCComponent from "./yc-component";
import {discardGameInstance} from "../actions/game-instance-actions";
import {listResourcesIfNeeded} from "../../../common/crud-actions";

class Background extends YCComponent {

    render() {
        return (
            <div id='game-bg'/>
        );
    }

}

function mapStateToProps(state,ownProps) {
    return {
        theme: state.theme
    };
}

export default connect(mapStateToProps)(Background);
